import { useEffect, useState } from 'react';
import { IWorkspace, IWorkspaceContext } from 'wisestep-base';

import { useWorkspaceContext } from '../../../../context/WorkspaceContext/WorkspaceContext';

import WorkspaceInfo from './WorkspaceInfo';

const Workspace = () => {
  const workspaceContext = useWorkspaceContext();
  const [workspace, setWorkspace] = useState<IWorkspace | IWorkspaceContext | null>(null);

  useEffect(() => {
    workspaceContext?.id && setWorkspace(workspaceContext);
  }, [workspaceContext]);

  return <>{workspace && <WorkspaceInfo workspace={workspace}></WorkspaceInfo>}</>;
};

export default Workspace;
